import { createI18n } from 'vue-i18n';
import en from '../locales/en.json';
import uk from '../locales/uk.json';
import pl from '../locales/pl.json';

const messages = {
  en,
  uk,
  pl
};

const i18n = createI18n({
  locale: 'en', // Set default locale
  fallbackLocale: 'en',
  messages
});

export default i18n;